<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title">
      {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINKED.ADD' | translate }}
    </h2>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div class="field-dialog__content">
    <form
      #form
      fxLayout="column"
      autocomplete="off"
      class="tab-groups field-dialog__content__scroll"
      fusePerfectScrollbar
    >
      <div class="field-outline-form">
        <div class="search-bar">
          <mat-form-field appearance="outline">
            <mat-label> {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINK.SEARCH' | translate }} </mat-label>
            <mat-icon matPrefix color="primary">search</mat-icon>
            <input matInput [formControl]="searchInput" />
            <mat-hint>
              {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.SEARCH_SUGGESTION' | translate }}
            </mat-hint>
          </mat-form-field>
        </div>
      </div>

      <div class="tab-groups__title-wrapper">
        <p class="tab-groups__title-text">
          {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINK.TITLE' | translate }} ({{ page?.totalCount || 0 }})
        </p>

        <mat-checkbox
          data-cy="select-all-checkbox"
          *ngIf="page?.items?.length"
          [disabled]="isLoading || isPageChanging || isSaving"
          [checked]="isAllSelected"
          (change)="toggleAllSelected($event.checked)"
        >
        </mat-checkbox>
      </div>

      <ng-container *ngIf="isLoading; else pageTemplate">
        <div class="loading">
          <mat-spinner class="loading__spinner" diameter="64"></mat-spinner>
          <span class="loading__text"> {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LOADING' | translate }}</span>
        </div>
      </ng-container>
      <ng-template #pageTemplate>
        <div class="card-list">
          <ng-container *ngIf="page?.items?.length; else noGroups">
            <div class="card-list__item" *ngFor="let group of page.items">
              <div class="card-list__item-content">
                <p class="card-list__item-title">
                  {{ group.name }}
                  <span class="card-list__archived-item" *ngIf="group.archived">
                    {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINK.ARCHIVED' | translate }}
                  </span>
                </p>
                <p class="card-list__item-description">{{ group.description }}</p>
              </div>

              <div class="card-list__item-control">
                <p *ngIf="group.locationsConnection.items.length; else linkLocationTemplate">
                  {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINK.ALREADY_LINKED' | translate }}
                </p>
                <ng-template #linkLocationTemplate>
                  <mat-checkbox
                    (change)="toggleSegmentLinkedToGroup($event.checked, group)"
                    [disabled]="isLoading"
                    [checked]="groupsToAdd.has(group.id)"
                  ></mat-checkbox>
                </ng-template>
              </div>
            </div>

            <div class="card-list__paginator-wrapper">
              <fc-paginator
                class="card-list__paginator"
                #paginator
                [pageSize]="pageSize"
                [totalCount]="page?.totalCount"
                [currentPageLength]="page?.items.length"
                [isLoading]="isPageChanging"
                (page)="onPageChange($event)"
              >
              </fc-paginator>
            </div>
          </ng-container>
          <ng-template #noGroups>
            <p class="card-list__not-found">
              {{ 'LOCATIONS.DIALOG.TABS.TAB_GROUP.LINK.NOT_FOUND' | translate }}
            </p>
          </ng-template>
        </div>
      </ng-template>
    </form>
  </div>

  <div class="field-dialog__footer" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout="row">
    <button class="field-background" mat-raised-button (click)="continue()" [disabled]="isLoading || isSaving">
      {{ 'LOCATIONS.DIALOG.BUTTON.CONTINUE' | translate }}
    </button>

    <button class="field-background--stroked" mat-stroked-button mat-dialog-close>
      {{ 'LOCATIONS.DIALOG.BUTTON.BACK' | translate }}
    </button>
  </div>
</div>
